import { Card } from "antd";
import { getMurphyPanelAsistente } from "../globals";


const HoverCard = () => {

    return (
        <div className="murphy-float">
        <Card style={{ width: 250, border:'none', padding: '0'}}>
        
                <span style={{ fontSize: "14px", fontWeight: "bold", height: 50, marginTop:'10px'}}>
                    {getMurphyPanelAsistente("textButton")}
                </span>
        

        </Card>
        </div>
    );
    };

export default HoverCard;